import { motion, AnimatePresence } from 'framer-motion';

export function TimeUpMessage({ show }: { show: boolean }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50"
        >
          <motion.div
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            className="bg-white/20 backdrop-blur-lg p-12 rounded-xl shadow-2xl text-center"
          >
            <h2 className="text-6xl font-bold text-white">Time's Up!</h2>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}